// extracted by mini-css-extract-plugin
export default {"tab":"Tabs_tab__1wFSD","tabs":"Tabs_tabs__l3BMJ","MuiTabs-indicator":"Tabs_MuiTabs-indicator__v1zeb"};